var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlashRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.44 7.14692H10.38V2.34692C10.38 1.22692 9.77334 1.00026 9.03334 1.84026L8.50001 2.44692L3.98667 7.58026C3.36667 8.28026 3.62667 8.85359 4.56001 8.85359H6.62001V13.6536C6.62001 14.7736 7.22667 15.0003 7.96667 14.1603L8.50001 13.5536L13.0133 8.42026C13.6333 7.72026 13.3733 7.14692 12.44 7.14692Z",
    fill: "#ED6767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashRed);
export default __webpack_public_path__ + "static/media/flash-red.a60ba26ed813215374e7c4bac5c0365d.svg";
export { ForwardRef as ReactComponent };